import api from "@/lib/api";

const same = (a, b) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null);

// Bewerk uitsluitend deze inzending. Gelijktijdig ingevulde andere formulieren blijven behouden.
export async function saveRegistration(submission, baseline) {
  for (let attempt = 0; attempt < 3; attempt += 1) {
    const { data } = await api.get("/appdata");
    const list = data.data?.regFormInzendingen;
    if (!Array.isArray(list)) throw new Error("Registraties konden niet volledig worden geladen. Je invoer is niet overschreven.");
    const current = list.find((s) => String(s.id) === String(submission.id)) || null;
    if (same(current, submission)) return list;
    if (!same(current, baseline)) throw new Error("Dit formulier is intussen door iemand anders gewijzigd. Je invoer blijft bewaard; controleer de andere versie voordat je verdergaat.");
    const next = current ? list.map((s) => String(s.id) === String(submission.id) ? submission : s) : [submission, ...list];
    try {
      await api.put("/instellingen/regFormInzendingen", { base_value: list, value: next });
    } catch (error) {
      if (error.response?.status === 409 && attempt < 2) continue;
      throw error;
    }
    const verified = (await api.get("/appdata")).data.data?.regFormInzendingen;
    if (!Array.isArray(verified) || !same(verified.find((s) => String(s.id) === String(submission.id)), submission)) throw new Error("De serverbevestiging ontbreekt. Bewaar je invoer en probeer opnieuw.");
    return verified;
  }
}

// Verwijder UITSLUITEND deze ene inzending definitief (vanuit de prullenbak). Alle andere
// formulieren blijven onaangeroerd; dezelfde optimistische-concurrency-bescherming als opslaan.
export async function purgeRegistration(submissionId, baseline) {
  for (let attempt = 0; attempt < 3; attempt += 1) {
    const { data } = await api.get("/appdata");
    const list = data.data?.regFormInzendingen;
    if (!Array.isArray(list)) throw new Error("Registraties konden niet volledig worden geladen. Er is niets verwijderd.");
    const current = list.find((s) => String(s.id) === String(submissionId)) || null;
    if (!current) return list; // al weg
    if (!same(current, baseline)) throw new Error("Dit formulier is intussen gewijzigd. Er is niets verwijderd; vernieuw eerst de prullenbak.");
    const next = list.filter((s) => String(s.id) !== String(submissionId));
    try {
      await api.put("/instellingen/regFormInzendingen", { base_value: list, value: next });
    } catch (error) {
      if (error.response?.status === 409 && attempt < 2) continue;
      throw error;
    }
    const verified = (await api.get("/appdata")).data.data?.regFormInzendingen;
    if (!Array.isArray(verified) || verified.find((s) => String(s.id) === String(submissionId))) throw new Error("De serverbevestiging ontbreekt. Probeer opnieuw.");
    return verified;
  }
}
